import React from 'react';
import { motion } from 'framer-motion';
import { FaCheck, FaMapMarkerAlt, FaTruck, FaCreditCard, FaClipboardCheck } from 'react-icons/fa';

const StepIndicator = ({ currentStep, onStepClick }) => {
    const steps = [
        { id: 1, label: 'Address', icon: FaMapMarkerAlt },
        { id: 2, label: 'Shipping', icon: FaTruck },
        { id: 3, label: 'Payment', icon: FaCreditCard },
        { id: 4, label: 'Review', icon: FaClipboardCheck }
    ];

    return (
        <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            className="mb-8 md:mb-12"
        >
            <div className="flex items-center justify-between">
                {steps.map((step, index) => (
                    <React.Fragment key={step.id}>
                        {/* Step */}
                        <motion.button
                            onClick={() => onStepClick(step.id)}
                            disabled={step.id > currentStep}
                            className="flex flex-col items-center relative group"
                            whileHover={step.id <= currentStep ? { y: -2 } : {}}
                        >
                            {/* Step Circle */}
                            <div className={`
                w-12 h-12 rounded-full flex items-center justify-center mb-2
                transition-all duration-300
                ${step.id === currentStep
                                ? 'bg-gradient-to-br from-champagne to-champagne/80 text-white scale-110'
                                : step.id < currentStep
                                    ? 'bg-gradient-to-br from-sage to-sage/80 text-white'
                                    : 'bg-nude/30 text-charcoal/30'
                            }
                ${step.id <= currentStep ? 'cursor-pointer' : 'cursor-not-allowed'}
              `}>
                                {step.id < currentStep ? (
                                    <FaCheck className="w-5 h-5" />
                                ) : (
                                    <step.icon className="w-5 h-5" />
                                )}
                            </div>

                            {/* Step Label */}
                            <span className={`
                text-sm font-medium transition-colors
                ${step.id === currentStep ? 'text-charcoal' :
                                step.id < currentStep ? 'text-sage' : 'text-charcoal/30'}
              `}>
                {step.label}
              </span>

                            {/* Active Indicator */}
                            {step.id === currentStep && (
                                <motion.div
                                    layoutId="step-indicator"
                                    className="absolute -bottom-2 w-12 h-1 bg-gradient-to-r from-champagne to-sage rounded-full"
                                />
                            )}
                        </motion.button>

                        {/* Connector Line */}
                        {index < steps.length - 1 && (
                            <div className="flex-1 h-px bg-nude/30 relative -top-6">
                                {step.id < currentStep && (
                                    <motion.div
                                        initial={{ width: '0%' }}
                                        animate={{ width: '100%' }}
                                        transition={{ duration: 0.6 }}
                                        className="absolute h-full bg-gradient-to-r from-sage to-champagne"
                                    />
                                )}
                            </div>
                        )}
                    </React.Fragment>
                ))}
            </div>

            {/* Progress Bar */}
            <div className="mt-8 h-1 bg-nude/30 rounded-full overflow-hidden">
                <motion.div
                    initial={{ width: '0%' }}
                    animate={{ width: `${((currentStep - 1) / (steps.length - 1)) * 100}%` }}
                    transition={{ duration: 0.8, ease: "easeOut" }}
                    className="h-full bg-gradient-to-r from-sage via-champagne to-sage rounded-full"
                />
            </div>
        </motion.div>
    );
};

export default StepIndicator;